// その他の求人
import { apiFetch } from '@common/utils/apiFetch'
import { fadeIn, fadeOut } from '@pc/components/Fade'

const groupWorks = document.querySelectorAll<HTMLElement>('.js-group-works')
const groupModalOpen = document.querySelectorAll<HTMLElement>('.js-group-modal-open')
const groupModalClose = document.querySelectorAll<HTMLElement>('.js-group-modal-close')
const groupModal = document.querySelectorAll<HTMLElement>('.js-group-modal')
const groupModalDialog = document.querySelectorAll<HTMLElement>('.js-group-modal-dialog')
const groupModalParams = document.querySelectorAll<HTMLInputElement>('.js-group-model-params')
const groupModalBody = document.querySelectorAll<HTMLElement>('.js-group-model-body')
const groupModalButton = document.querySelectorAll<HTMLElement>('.js-group-modal-button')

export function displayGroupWorks() {
  if (groupWorks.length === 0 || groupModalOpen.length === 0) return
  if (groupWorks.length !== groupModalOpen.length) return

  for (let i = 0; i < groupWorks.length; i++) {
    const requester = createRequester(i)
    groupModalOpen[i].addEventListener('click', () => {
      fadeIn(groupModal[i])
      requestFirstPage(requester, i)
    })
    groupModalClose[i].addEventListener('click', () => {
      const body = groupModalBody[i]
      body.innerHTML = ''
      requester.refresh()
      fadeOut(groupModal[i])
    })
    groupModalButton[i].addEventListener('click', () => {
      requestNextPage(requester, i)
    })
    groupModalDialog[i].addEventListener('click', (e) => {
      e.stopPropagation()
    })
  }
}

function createRequester(index: number) {
  const json: GroupParams = JSON.parse(groupModalParams[index].value)
  const params = new GroupParams(json.fq, json.sort, json.shops_group, json.work_id, 1)
  const requester = new GroupRequester(params)
  requester.errorHandler = (error) => {
    console.error(error)
  }
  requester.finishedHandler = () => {}
  return requester
}

interface GroupWorksData {
  works: Array<{ id: string; name: string }>
  total_page: number
  page: number
}

// 求人名は広告主の入力値のため、innerHTMLではなくテキストノードとして挿入する（XSS対策）
export const createWorkItem = (id: string, name: string) => {
  const link = document.createElement('a')
  link.href = `/detail/${encodeURIComponent(id)}`
  link.textContent = name

  const li = document.createElement('li')
  li.className = 'p-works-grouped-works-li-style'
  li.append(link)
  return li
}

const createWorkItems = (data: GroupWorksData) => data.works.map((work) => createWorkItem(work.id, work.name))

function requestFirstPage(requester: GroupRequester, index: number) {
  requester.successHandler = (data) => {
    const body = groupModalBody[index]
    body.replaceChildren(...createWorkItems(data))
    groupModalButton[index].style.display = data.total_page !== data.page ? 'block' : 'none'
  }
  requester.fetch()
}

function requestNextPage(requester: GroupRequester, index: number) {
  requester.successHandler = (data) => {
    const body = groupModalBody[index]
    body.append(...createWorkItems(data))
    if (data.total_page === data.page) {
      groupModalButton[index].style.display = 'none'
    }
  }
  requester.nextFetch()
}

class GroupParams {
  fq: string
  sort: string
  shops_group: string
  work_id: string
  page: number

  constructor(fq: string, sort: string, shopsGroup: string, workId: string, page: number) {
    this.fq = fq
    this.sort = sort
    this.shops_group = shopsGroup
    this.work_id = workId
    this.page = page
  }
}
class GroupRequester {
  params: GroupParams
  successHandler: (data: GroupWorksData) => void = () => {}
  errorHandler: (error: unknown) => void = () => {}
  finishedHandler: () => void = () => {}

  constructor(params: GroupParams) {
    this.params = params
  }

  async fetchGroupWorks(params: GroupParams) {
    const query = new URLSearchParams({
      fq: params.fq,
      sort: params.sort,
      shops_group: params.shops_group,
      work_id: params.work_id,
      page: String(params.page)
    })
    const response = await apiFetch(`/api/groups?${query.toString()}`)
    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`)
    return (await response.json()) as GroupWorksData
  }

  fetch() {
    void this.fetchGroupWorks(this.params)
      .then((data) => {
        this.successHandler(data)
      })
      .catch((error) => {
        this.errorHandler(error)
      })
      .finally(() => {
        this.finishedHandler()
      })
  }

  nextFetch() {
    this.params.page++
    void this.fetchGroupWorks(this.params)
      .then((data) => {
        this.successHandler(data)
      })
      .catch((error) => {
        this.errorHandler(error)
      })
      .finally(() => {
        this.finishedHandler()
      })
  }

  refresh() {
    this.params.page = 1
  }
}
